import React, {useCallback} from 'react';
import {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {toggleControlSidebar, toggleSidebarMenu} from '@app/store/reducers/ui';
import UserDropdown from '@app/modules/main/header/user-dropdown/UserDropdown';
import {getAllUserNames} from '@app/services/auth';
import {dateConvertorForBirthdayPopup} from '../../../utils/ajax';

const Header = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navbarVariant = useSelector((state: any) => state.ui.navbarVariant);
  const headerBorder = useSelector((state: any) => state.ui.headerBorder);
  const [show, setShow] = useState(false);
  const [users, SetUsers] = useState([]);

  
  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const getAllUsersBirthday = async () => {
    const res = await getAllUserNames();
    if ((res.data.ok = true)) {
      SetUsers(res.data.data);
    }
  };

  useEffect(() => {
    getAllUsersBirthday();
  }, []);

  const handleToggleControlSidebar = () => {
    dispatch(toggleControlSidebar());
  };

  const getContainerClasses = useCallback(() => {
    let classes = `main-header navbar navbar-expand ${navbarVariant}`;
    if (headerBorder) {
      classes = `${classes} border-bottom-0`;
    }
    return classes;
  }, [navbarVariant, headerBorder]);

  function BirthdayPopup(props: any) {
    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show
        onHide={props.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Birthdays</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-b-day">
          {props.users &&
            props.users.map((val: any, idx) => {
              if (
                val.profile === '' ||
                val.profile === undefined ||
                val.profile === null
              ) {
                val.profile = '/img/default-profile.png';
              }

              if (val.dob) {
                const obj = {
                  '01': 'Jan',
                  '02': 'Feb',
                  '03': 'Mar',
                  '04': 'Apr',
                  '05': 'May',
                  '06': 'June',
                  '07': 'July',
                  '08': 'August',
                  '09': 'September',
                  '10': 'October',
                  '11': 'November',
                  '12': 'December'
                };

                const split = val.dob.split('-');
                var dob = `${split[2]}  ${obj[split[1]]}`;
              }

              return (
                <Card key={idx} style={{width: '8rem', margin: '5px'}}>
                  <Card.Img
                    variant="top"
                    src={val.profile}
                    className="card-img"
                  />
                  <Card.Body>
                    <Card.Title className="title-of-b-day">
                      {val.name}
                    </Card.Title>
                    <Card.Title className="title-of-b-day">
                      {val.dob === null || val.dob === undefined ? '' : dob}
                    </Card.Title>
                  </Card.Body>
                </Card>
              );
            })}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      <nav className={getContainerClasses()}>
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              onClick={handleToggleMenuSidebar}
              type="button"
              className="nav-link"
            >
              <i className="fas fa-bars" />
            </button>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link to="/" className="nav-link">
              {t<string>('header.label.home')}
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav">
          <Link to="#" className="nav-link" onClick={handleShow}>
            Birthdays
          </Link>
        </ul>
        <ul className="navbar-nav ml-auto">
          <UserDropdown />
        </ul>
      </nav>
      {show && <BirthdayPopup handleClose={handleClose} users={users} />}
    </>
  );
};

export default Header;
